import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import "./css/historiqueClient.css";
import noImage from "../../Image/no-image.jpg";
import { BASE_URL } from "../../Utils/base_url";
import Spinner from "react-bootstrap/Spinner";
import Pagination from '@material-ui/lab/Pagination';
import { AfficheResevationHistorique } from "../../Api/ClientApi/ResaAvisApi";
import db from '../../db';

const Historique = () => {
  const [loadData, setLoadData] = useState(false);
  const [dataResa, setDataResa] = useState([]);
  const [data, setData] = useState([]);
  const [showPaginate, setShowPaginate] = useState(true);
  const [totalPage, setTotalPage] = useState();
  const [page, setPage] = useState(1);
  const [test,setTest] = useState([]);

  let navigate = useNavigate();
  let location = useLocation();
  const client = useSelector((state) => state.client);
  const ResaAnnuler = dataResa.filter((el) => el.etat === "Annuler");

  useEffect(() => {
    const fetchAndSetData = async()=> {
    try {
      const donner = await db.monTableau.toArray();
      if (donner.length > 0) {
        setTest(donner);
        console.log("Donner dans dexi=>",donner);
      }
    } catch (error) {
      console.error('Erreur lors de la récupération des données depuis Dexie :', error);
    }
  };
  fetchAndSetData();
  }, []);

  useEffect(() => {
    AfficheReservationClient();
    if (dataResa.length < 4) {
      setShowPaginate(false);
    } else {
      setShowPaginate(true);
    }
  }, [dataResa.length]);

  const AfficheReservationClient = (value = null) => {
    let dataPage = value === null ? page : value;
    setLoadData(true);
    AfficheResevationHistorique(client.id, dataPage)
      .then(function (response) {
        console.log("data =>", response.data.donner);
        setData(response.data.donner);
        setDataResa(response.data.reservations);
        setTotalPage(response.data.totalPage);
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(function () {
        setLoadData(false);
      });
  };

  const safeParseFloat = (str) => {
    const value = Number.parseFloat(str);

    return Number.isNaN(value) ? 0 : value;
  };
  const formatPlural = (value) => {
    if (value < 10) {
      return "0" + value;
    } else {
      return value;
    }
  };

  const formatDate = (date) => {
    const datePrise = new Date(date);
    return (
      formatPlural(datePrise.getDate()) +
      "/" +
      formatPlural(datePrise.getUTCMonth() + 1) +
      "/" +
      datePrise.getFullYear()
    );
  };

  const formatTime = (time) => {
    return formatPlural(new Date(time).getHours()) + "H:" + formatPlural(new Date(time).getMinutes());
  };

  const viewReservation = (item, index) => {
    const restaurant = test?.find(
      (el) => el.id === parseInt(item.restaurant?.id)
    );

    const notes = safeParseFloat(
      restaurant?.notes.reduce(
        (prevNote, currentNote) => prevNote + parseInt(currentNote.note),
        0
      ) / restaurant.notes.length
    );

    return (
      <div className="card" key={index}>
        <div className="row">
          <div className="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3">
            <div className="image_card">
              <img
                src={
                  restaurant?.photos.length === 0
                    ? noImage
                    : BASE_URL + restaurant?.photos[0]?.urlPhoto
                }
                alt="logo restaurant"
              />
            </div>
          </div>
          <div className="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3">
            <div className="apropos_restaurant">
              <span>{restaurant?.typeCuisines[0].libelle}</span>
              <h3>{restaurant.nomRestaurant}</h3>
              <span>{restaurant.adresse} </span>
              <div className="note_avis">
                <span className="note">Note: {notes.toFixed(2)}/20</span>
                <span className="avis">Avis: {restaurant?.avis.length}</span>
              </div>
            </div>
          </div>
          <div className="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3">
            <div className="apropos_reservation shadow-sm">
              <div>
                <span className="date">
                  Réservation du {formatDate(item.datePrise)}
                </span>
              </div>
              <div className="mt-1">
                <span className="heure">à {formatTime(item.heurePrise)}</span>
              </div>
              <div className="mt-1">
                <span className="personne">Pour {item.nombrePersonne} personnes</span>
              </div>
              <div className="status">
                <span className="terminer">{item.etat}</span>
              </div>
            </div>
          </div>
          <div className="col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3">
            {item.etat === "Annuler" ? <div className="button_successAnnuler">
              <button className="btn">Réservation à été annuler</button>
            </div> : <div className="button_annuler">
              <button className="btn" onClick={() => handleAnnulerReservation(item.id, restaurant.id)}>Annuler la réservation</button>
            </div>}


          </div>
        </div>
      </div>
    );
  };

  const handleAnnulerReservation = (idReservation, idRestaurant) => {
    navigate('/annulation', { state: { idRestaurant: idRestaurant, idReservation: idReservation } });
  }

  const handlePage = (event, value) => {
    setPage(value);
    AfficheReservationClient(value);
  }

  return (
    <div>
      <Helmet>
        <title>Historique des réservations</title>
        <meta name="description" content="Historique des réservations" />
        <link rel="canonical" href={location.pathname} />
      </Helmet>
      <div className="historique">
        <div className="container">
          <div className="bloc_historique">
            <div className="titre">
              <h1>
                <i className="fa fa-bookmark"></i>Mes réservations
              </h1>
            </div>
            <div className="sous_titre">
              <h2>
                Nombre des réservations : {dataResa.length} {" "} dont {ResaAnnuler.length} annulée
              </h2>
            </div>
            <div className="liste_restaurant">
              {loadData === true ?
                <div className="d-flex justify-content-center">
                  <Spinner
                    animation="border"
                    className="load"
                    variant="info"
                    size="md"
                  />
                </div> : data.map((item, index) => {
                  return viewReservation(item, index);
                })
              }
            </div>
            {showPaginate && <div className='d-flex justify-content-center mt-4'>
              <Pagination
                shape="rounded"
                count={Math.ceil(totalPage)}
                onChange={handlePage}
              />
            </div>
            }
            <p className="version">Version 1</p>
          </div>

        </div>

      </div>
    </div>
  );
};

export default Historique;
